import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import StickyActions from './components/StickyActions';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import References from './pages/References';
import Employees from './pages/Employees';
import Contact from './pages/Contact';

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="relative min-h-screen bg-slate-950 text-white antialiased flex flex-col justify-between font-sans">
        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/ydelser" element={<Services />} />
            <Route path="/ydelser/:subService" element={<ServiceDetail />} />
            <Route path="/referencer" element={<References />} />
            <Route path="/medarbejdere" element={<Employees />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/kontakt/uopfordret-ansoegning" element={<Contact />} />
            {/* Fallback route */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        {/* Sticky Floating Actions */}
        <StickyActions />

        {/* Columnar Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
